import * as React from 'react'

const NonceContext = React.createContext<string>('')
const NonceProvider = NonceContext.Provider
const useNonce = () => React.useContext(NonceContext)

export { NonceContext, NonceProvider, useNonce }
